import { MetricBlock } from "../../../types/storyMap";
import MetricItemFields from "./MetricItemFields";
import type { ScopeLists } from "../useScopeLists";
import type { StoryScopeInfo } from "../useStoryScope";

interface MetricBlockEditorProps {
  block: MetricBlock;
  onChange: (patch: Partial<MetricBlock>) => void;
  scope: StoryScopeInfo;
  lists: ScopeLists;
}

export default function MetricBlockEditor({ block, onChange, scope, lists }: MetricBlockEditorProps) {
  return <MetricItemFields item={block} onChange={onChange} scope={scope} lists={lists} />;
}
